require('./itemDetails.less');

class ItemDetailsController {
    activeItem;
    selectedIndex = 0;
    sumOfAllStocks;

    toolbarheaderDefinition = {
        isTable: true,
        previousStateArrowActive: true,
        toolbarHeading: "",
    };

    stockUpdateFunction = (val) => {
        this.sumOfAllStocks = val;
    };

    constructor(private toastService, private Items, private $stateParams){
    }

    $onInit() {
        this.Items.getItem({itemId: this.$stateParams.itemId}).$promise.then((item) => {
            this.activeItem = item;
            this.toolbarheaderDefinition.toolbarHeading = "Vareoversikt for " + item.name;
        }, (error) => {
            this.toastService.parseError(error);
        });
    }
}

class ItemDetailsOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcItemDetailsController";
    public template: any = require('./itemDetails.html');
}

rkcApp.controller("rkcItemDetailsController", ['toastService', 'Items', '$stateParams', function(toastService, Items, $stateParams){
    return new ItemDetailsController(toastService, Items, $stateParams);
}])
    .component("rkcItemDetails", new ItemDetailsOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/items/itemDetails/itemDetails.ts
 **/